import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  topScrollPaper: {
    alignItems: 'flex-start'
  },
  topPaperScrollBody: {
    verticalAlign: 'top'
  },
  ratios: {
    display: 'flex',
    gap: 16,
    justifyContent: 'center',
    marginBottom: 16
  },
  content: {
    width: '1280px',
    height: '700px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  container: {
    margin: ' 10px 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& button': {
      alignSelf: 'flex-start'
    }
  },
  img: {
    '& img': {
      maxWidth: '100%',
      maxHeight: '550px',
      height: 'auto',
      width: 'auto'
    }
  }
}));
